import React, { Component } from 'react';
import { API_BASE_URL } from "../../constants";
import LoadingIndicator from "../../common/LoadingIndicator";
import Alert from "react-s-alert";

class NobetTalepForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            requestInfo: {
                description: "",
                date: "",
                id:null,
            },
        };
    }

     componentDidMount() {
           const { selectedRequest } = this.props;
           if (selectedRequest) {
               const { description, date, id } = selectedRequest;
               this.setState(prevState => ({
                   requestInfo: {
                       ...prevState.requestInfo,
                       description: description,
                       date: date,
                       id: id
                   }
               }));
           }
       }

       onChange = (e) => {
           const { name, value } = e.target;
           this.setState(prevState => ({
               requestInfo: {
                   ...prevState.requestInfo,
                   [name]: value
               }
           }));
       }

       saveRequest = () => {
           const { onCancel, handleSearch, add } = this.props; // add özelliğini al
           const { requestInfo } = this.state;

           const validity = this.validateComponent();
           if (validity.valid) {
               this.setState({ isLoading: true });

               let data;
               let message;
               let url;
               if (add) {
                   message = 'Talep başarıyla kaydedildi.';
                  url = `${API_BASE_URL}/nobettalep/add`;

                   data = requestInfo;
               } else {
                   message = 'Talep başarıyla güncellendi.';
                  url = `${API_BASE_URL}/nobettalep/${requestInfo.id}`;

                   data = requestInfo;
               }

               fetch(url, {
                   method: add ? "POST" : "PUT",
                   headers: {
                       Authorization: "Bearer " + localStorage.getItem("accessToken"),
                       "Content-Type": "application/json"
                   },
                   body: JSON.stringify(data)
               })
               .then(response => {
                   if (!response.ok) {
                       throw new Error("Network response was not ok");
                   }
                   return response.json();
               })
               .then(() => {
                   Alert.success(message, {
                       position: 'top-right',
                       effect: 'stackslide',
                       timeout: 5000
                   });
                   this.setState({ isLoading: false, requestInfo: { description: "", date: "", id: null } });
                   onCancel();
                   handleSearch();
               })
               .catch(error => {
                   this.setState({ isLoading: false });
                   console.error("There was a problem with the fetch operation:", error);
                   Alert.error("Talep kaydedilirken bir hata oluştu. Lütfen tekrar deneyin.", {
                       position: 'top-right',
                       effect: 'stackslide',
                       timeout: 5000
                   });
               });
           } else {
               Alert.error('Hatalı veya eksik alanlar var!', {
                   position: 'top-right',
                   effect: 'stackslide',
                   timeout: 5000
               });
           }
       }


    validateComponent = () => {
     return { valid: true };
    }


render() {
      const { description, date } = this.state.requestInfo;
            const { onCancel } = this.props;
            const { isLoading } = this.state;

            return (
                <div className="memberForm--main-container">
                    {isLoading && <LoadingIndicator />}
                    <div className="memberForm-container">
                        <div className="FormRenk col-sm-12">
                            <span className="form-title">Talep Bilgileri</span>
                            <div className="row">
                                <label className="col-sm-3">Talep Açıklama: </label>
                                <div className="col-sm-8 form-group">
                                    <input
                                        className="form-control"
                                        type="text"
                                        name="description"
                                        value={description}
                                        onChange={this.onChange}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <label className="col-sm-3">Tarih: </label>
                                <div className="col-sm-8 form-group">
                                    <input
                                        className="form-control"
                                        type="date"
                                        name="date"
                                        value={date}
                                        onChange={this.onChange}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="save-button-container mb-5">
                            <button
                                className="member-save-button"
                                onClick={this.saveRequest}
                                disabled={isLoading}
                            >
                                Kaydet
                            </button>
                        </div>
                    </div>
                </div>
            );
        }
    }
export default NobetTalepForm;


// WEBPACK FOOTER //
// ./src/page/nobetParams/NobetTalepForm.js